<template>
  <div>
      <Header title="即时评教" type="0" route="/teacher/evaluateOnTime" ></Header>
      <div class="tittleDiv">
        <div class="list-head">
          <p>{{baseData.kcmc}}</p>
          <ul>
            <li><div>上课班级：{{ baseData.ktmc }}</div></li>
            <li><div>上课人数：{{ baseData.xkrs }}</div></li>
          </ul>
          <div class="xsdiv">
            <div><p>评价人数：{{baseData.pjrs}}</p></div>
            <div><p>评价人次：{{baseData.pjrc}}</p></div>
          </div>
		    </div>
      </div>
      <NOdata v-if="evaluateList.length == 0" title="暂无评教记录~"></NOdata>
      <div class="eva-body" v-else>
        <p>评论时间：{{pjTIme}}</p>
        <keep-alive>
				<textarea
				  placeholder=""
				  v-model="evaText"
				  maxlength="2000"
          readonly
				></textarea>
			  </keep-alive>
        <div class="eva-body-ts">
          <van-pagination v-model="currentPage" :page-count="pangCont"  mode="simple"  prev-text="上一条" next-text="下一条"></van-pagination>
        </div>
       <!--- <div class="grey-contain">
          
        </div>-->
        <div class="grey-contain_div" ></div>
      </div>
      <div class="history-btn">
        <button @click="goBack()">返回</button>
      </div>
  </div>
</template>

<script>
  import {Api} from '../../../utils/axios'
  export default {
    data(){
      return{
        evaluateList:[],
        warning:'',
        baseData:JSON.parse(this.$route.query.itemObj),
        evaText:'',
        currentPage:1,
        pangCont:10,
        pjTIme:'',
        dataPageCount:30,
        startPageCount:1,
        endPageCount:this.startPageCount+this.dataPageCount-1
      }
    },
    watch:{
      currentPage(val){
        if(val-this.startPageCount>=this.dataPageCount){
          this.startPageCount = val;
          this.initData();
        }else if(val<this.startPageCount){
          this.startPageCount = this.startPageCount-this.dataPageCount;
          this.initData();
        }else{
          this.evaText = this.evaluateList[val-this.startPageCount].pjnr;
          this.pjTIme = this.evaluateList[val-this.startPageCount].pjsj;
        }
        
      }
    },
    methods:{
      async initData(){
        const params = {
          jx0404id:this.baseData.jx0404id,
          startPage:this.startPageCount,
          pageCout:this.dataPageCount
        };
        const res = await Api.getEvaluateRecode_teacher(params);
        if(res.code=='1'){
           this.evaluateList = res.data.dataList;
           this.pangCont = res.data.pangSize*1;
           if(this.evaluateList.length>0){
            this.evaText = this.evaluateList[this.currentPage-this.startPageCount].pjnr;
            this.pjTIme = this.evaluateList[this.currentPage-this.startPageCount].pjsj;
           }
           
        }
      },
      goBack(){
        this.$router.push({
                path: '/teacher/evaluateOnTime',
            });
      }
    },
    created(){
       this.initData();
    },
  }
</script>

<style lang="less" scoped>
.tittleDiv{
  padding: 3% 5% 0;
	background-color: #ffffff;
	height: 170px;
  .list-head {
	  height: 100%;
	  background-image: url("../../../../static/image/head.png");
	  background-size: 100% 100%;
	  background-repeat: no-repeat;
	  display: flex;
	  padding: 4% 5%;
	  box-sizing: border-box;
	  position: relative;
	  flex-direction: column;
	  z-index: 1;
	  p {
		height: 22px;
		font-family: PingFangSC-Medium;
		font-size: 18px;
		color: #fff;
		letter-spacing: 0;
		line-height: 22px;
		font-weight: 500;
		margin-bottom: 2%;
	  }
	ul li {
		  max-height: 35px;
		  font-family: PingFangSC-Regular;
		  font-size: 14px;
		  color: #fff;
		  letter-spacing: 0;
		  margin-bottom: 1%;
		  opacity: 0.8;
		}
    ul li div{
      width: 100%;
      max-height: 35px;
      overflow: hidden;
      text-overflow: ellipsis;
    }
	.xsdiv{
		background-color: rgba(143, 135, 249, 0.8);
		border-radius: 8px;
		height: 42px;
		line-height: 42px;
		margin-top: 10px;
		div{
		  width: 50%;
		  float: left;
		}
		p{
			font-family: PingFangSC-Regular;
		  font-size: 14px;
		  color: #fff;
		  letter-spacing: 0;
		  opacity: 0.8;
		  display:inline-block;
		 padding-left: 10px;
		}

	}
	}
}
.grey-contain{display: flex;align-items: center;}
.grey-contain h4{overflow: hidden;white-space: nowrap;text-overflow: ellipsis;line-height: 22px;}
  .grey-contain button{background-color: @attendance-background-color-1;border-radius: 3px;color: @attendance-color-3;height: 45px;width: 70px;}
  .grey-contain .contain-txt1{line-height: 17px;}
  .grey-contain  p{margin-bottom: 2px;}
  .delay-btn{position: absolute;bottom: 20px;width: 100%;text-align: center;}
  .delay-btn button{background-color: @attendance-background-color-7;color: @attendance-background-color-1;padding: 11px 0;width: 90%;border-radius: 3px;}
  .history{border-radius: 3px;background-color: @attendance-background-color-13;color: @attendance-color-3;height: 45px;width: 70px;display: flex;flex-direction: column;align-items: center;justify-content: center;}
  .history h1{font-size: 16px;font-weight: 400;}
  .history p{font-size: 10px;}
  .eva-body{
    padding: 3% 5% 0;
    position: fixed;
    top: 225px;
    bottom: 90px;
    width: 95%;
    p{
      font-family: PingFangSC-Medium;
      color: #151618;
      font-size: 15px;
      font-weight: 600;
      line-height: 25px;
    }
    span {
      color: @attendance-color-2;
      position: relative;
      bottom: 0px;
      right: 10px;
      color: red;
      font-size: 12px;
   }
   .eva-body-ts{
     padding: 3% 5% 0;
     padding-top:0;
     padding-left: 0;
     text-align: center;

   }
  }
  .history-btn{position: fixed;bottom: 0;width: 100%;background-color: @attendance-color-3;text-align: center;padding: 0 10px;box-sizing: border-box;height: 85px;}
  .history-btn button{width:100%;background-color: @attendance-background-color-7;color: @attendance-background-color-1;margin:20px 0;border-radius: 3px;padding: 11px 0}
  .grey-contain_div{display: flex;align-items: center;background-color: white;}

 .eva-body textarea {
   width: 95%;
   padding: 10px;
   background-color: @attendance-background-color-6;
   border-radius: 3px;
   box-sizing: border-box;
   color: @attendance-color-1;
   height: 85%;
   padding-bottom: 15px;
   position: relative;
 }

</style>

<style lang="less" scoped>
 

 /deep/ .van-pagination__item {
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    flex: 1;
    box-sizing: border-box;
    min-width: 36px;
    height: 40px;
    color: #7469F8;
    background-color: #fff;
    cursor: pointer;
    -webkit-user-select: none;
    user-select: none;
}

/deep/ .van-pagination__item--active{
  color: #fff;
  background-color: #7469F8;
 }
</style>



// WEBPACK FOOTER //
// src/components/teacher/Evaluate1/evaluateOnTime_recode.vue